<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <edit-profile-form data-background-color="primary"> </edit-profile-form>
      </div>
    </div>
  </div>
</template>

<script>
import EditProfileForm from "@/pages/UserProfile/EditProfileForm";

export default {
  components: {
    EditProfileForm
  }
};
</script>
